import React from "react";

// @material-ui/icons
import { CircularProgress } from '@mui/material';
import DataTable from "components/Table/DataTable";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import { Box } from '@mui/material';
import { Alert } from '@mui/material';

// core components
import { useQuery } from "react-query";
import nodeImage from "assets/img/kubernetes_icon_black.png";
import { useToken } from "hooks/token.js";
import { useAxiosAuth } from "hooks/axios.js";

import axios from "axios";

export default function NodeTable(props) {
  const url = "/api/v1/k8s/nodes";
  const [token, setToken] = useToken();
  useAxiosAuth(token);
  const NodeName = ({ image, name }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar src={image} name={name} size="sm" />
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
  const columns = [
    { Header: "name", accessor: "name", width: "25%", align: "left" },
    { Header: "kernel", accessor: "kernel", align: "left" },
    { Header: "k8s version", accessor: "k8sversion", width: "20%", align: "center" },
    { Header: "OS", accessor: "os", align: "center" },
    { Header: "architecture", accessor: "architecture", align: "center" },
  ];

  const { isLoading, error, data } = useQuery(
    "node", () => axios.get(
      url,
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    ).then(
      (res) => (res.hasOwnProperty('data') && res.data.hasOwnProperty('data'))? res.data.data : null
    )
  )

  const nodeData = (data) => {
    let tableData = {
      columns: columns,
      rows: []
    };

    if (data) {
      if ("items" in data) {
        tableData.rows = data.items.map((item) => {
          const name = (item.name)? item.name : ""
          return {
            name: <NodeName image={nodeImage} name={name} />,
            kernel: (item.kernel_version) ? item.kernel_version : "",
            k8sversion: (item.kubelet_version) ? item.kubelet_version : "",
            os: (item.operating_system) ? item.operating_system : "",
            architecture: (item.architecture) ? item.architecture : ""
          }
        }
        )
      }
    }

    return tableData;
  }

  return (
    <React.Fragment>
      {error ?
        <Box sx={{ paddingBottom: "10px" }}>
          <Alert severity="error">
            "Error loading data"
          </Alert>
        </Box>
        : null
      }
      {(isLoading && !error) && <CircularProgress size={24} style={{marginLeft: '35%', position: 'fixed', top: '40%',  zIndex: '1'}}/> }
      {(!isLoading && !error) &&
        <DataTable
          table={nodeData(data)}
          showTotalEntries={false}
          isSorted={true}
          noEndBorder
          entriesPerPage={false}
        />
      }
    </React.Fragment>
  );
}
